import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {ReportBuilderService} from '../../report-builder.service';
import {SnackBarService} from '../../../../shared/services/snackbar.service';
import {GlobalSpinnerService} from '../../../../shared/components/loader-service/global-spinner.service';
import {ScheduledUserReport} from './scheduled-user-report.model';
import {DeliveryFrequency, DeliveryFrequencyLabelsKL} from '../../../../shared/domain/delivery-frequency.enum';
import {KeyLabel} from '../../../../shared/domain/key-label.model';
@Component({
  selector: 'cm-src-editor-dialog',
  template: `
    <span mat-dialog-title>Scheduled details</span>
    <div mat-dialog-content class="d-flex flex-column">
      <mat-form-field floatLabel="always">
        <input matInput placeholder="Email" [(ngModel)]="email" email>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-select placeholder="Delivery frequency" [(ngModel)]="config.deliveryFrequency">
          <mat-option *ngFor="let b of deliveryFrequencyKL" [value]="b.key">
            {{ b.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
      <button mat-raised-button color="primary"
              class="mr-1"
              (click)="save()">Save
      </button>
    </div>
  `,
})
export class ScheduledUserReportEditorDialogComponent {

  config: ScheduledUserReport;
  email: string;
  public deliveryFrequencyKL: KeyLabel<DeliveryFrequency>[] = DeliveryFrequencyLabelsKL();

  constructor(public dialogRef: MatDialogRef<ScheduledUserReportEditorDialogComponent>,
              private service: ReportBuilderService,
              private loader: GlobalSpinnerService,
              private sbs: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.config) {
      this.config = data.config;
      this.email = this.config.recipients && this.config.recipients.length ? this.config.recipients[0] : '';
    } else {
      this.config = new ScheduledUserReport();
      this.config.report = data.report;
      this.config.deliveryFrequency = DeliveryFrequency.DAILY;
      this.email = '';
    }
  }

  save() {
    this.loader.showLoader();
    this.config.recipients = [this.email];
    if (this.config.id) {
      this.service.scheduledUserConfigsPut(this.config).subscribe(next => {
          this.sbs.success('Scheduled report successfully updated!');
          this.dialogRef.close(true);
          this.loader.hideLoader();
        },
        () => {
          this.loader.hideLoader();
          this.sbs.success('Error occured during report saving');
        });
    } else {
      this.service.scheduledUserConfigsPost(this.config, this.config.report).subscribe(next => {
          this.sbs.success('Scheduled report successfully saved!');
          this.dialogRef.close(true);
          this.loader.hideLoader();
        },
        () => {
          this.sbs.success('Error occured during report saving');
          this.loader.hideLoader();
        });
    }
  }
  
}
